export const hexToRgbA = (hex, opacity) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    const resRgba =
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      ",?)".replace("?", opacity);
    return resRgba;
  }
  // assume the input is valid r,g,b
  return "rgba(" + hex + ", " + opacity + ")";
};

export function rgbToHex(rgbString) {
  if (!rgbString) {
    return rgbString;
  }

  rgbString = rgbString.replace(/\s/g, "");
  const rgbSplit = rgbString.split(",");
  if (rgbString[0] === "#" || rgbSplit.length !== 3) {
    return rgbString;
  }

  const r = parseInt(rgbSplit[0]);
  const g = parseInt(rgbSplit[1]);
  const b = parseInt(rgbSplit[2]);
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
